<script>
  import EditView from '../partials/EditView.vue'
  import FormInput from '../form/form-input.vue'
  import tokenMixin from '../form/token-mixin.js'

  import {
    BButton,
    BInputGroupAppend,
  } from 'bootstrap-vue'

  export default {
    components: {
      BButton,
      BInputGroupAppend,
      EditView,
      FormInput,
    },
    mixins: [
      tokenMixin
    ],
    props: {
        id: {
            type: String,
            required: true
        }
    },
  }
</script>
<template>
  <edit-view
    :id="id"
    v-slot="slotProps"
    store="repositorytoken"
    list-route="RepositoryTokenList"
  >
    <form-input
      :store="slotProps.store"
      prop-name="name"
      class="col-6"
    />
    <form-input
      :store="slotProps.store"
      prop-name="token"
      class="col-6"
    >
      <b-input-group-append>
        <b-button
          :title="$t('repositorytoken.token.generateTitle')"
          @click="$store.dispatch('repositorytoken/update/updateItem', {token: random()})"
        >
          <font-awesome-icon :icon="iconRandom" />
        </b-button>
      </b-input-group-append>
    </form-input>
  </edit-view>
</template>
